export default "__VITE_ASSET__Cxpx9sKg__"